module.exports = __webpack_public_path__ + "img/lbs1200jp01.02fb3ba8.jpg";